import BuildIcon from '@material-ui/icons/Build';
import labels from '../../labels';
import MaintenanceList from './MaintenanceList';

export default {
  name: 'Maintenance',
  list: MaintenanceList,
  icon: BuildIcon,
  options: {
    label: labels.maintenance
  }
};
